import { addDays, format } from 'date-fns'

import type { PinterestBoard, Service, Tag } from '../../graphqlTypes'

import type { UserFriendlyCsvLine } from './validators'

const imageOptions = [
  'https://images.unsplash.com/photo-1433086966358-54859d0ed716?q=80&w=1287&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://plus.unsplash.com/premium_photo-1719943510748-4b4354fbcf56?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1469474968028-56623f02e42e?q=80&w=2348&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1421789665209-c9b2a435e3dc?q=80&w=2342&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://plus.unsplash.com/premium_photo-1675827055620-24d540e0892a?q=80&w=972&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1501854140801-50d01698950b?q=80&w=2600&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1506744038136-46273834b3fb?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1470813740244-df37b8c1edcb?q=80&w=2342&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1615729947596-a598e5de0ab3?q=80&w=1287&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1458668383970-8ddd3927deed?q=80&w=2334&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1435224654926-ecc9f7fa028c?q=80&w=1287&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1506260408121-e353d10b87c7?q=80&w=2428&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1586348943529-beaae6c28db9?q=80&w=1315&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?q=80&w=2342&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1539634262233-7c0b48ab9503?q=80&w=2250&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1470240731273-7821a6eeb6bd?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1520716497194-0bde97ce9abe?q=80&w=1365&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  'https://images.unsplash.com/photo-1465189684280-6a8fa9b19a7a?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
]

export const constructCsvTemplate = ({
  channelService,
  existingTags,
  existingBoards,
}: {
  channelService?: Service
  existingTags: Tag[]
  existingBoards: PinterestBoard[]
}): UserFriendlyCsvLine[] => {
  const tomorrow = addDays(new Date(), 1)

  const tags =
    existingTags.length === 1
      ? existingTags[0].name
      : existingTags.length > 1
        ? existingTags.map((tag) => tag.name).join(', ')
        : 'tag1,tag2'
  const baseTemplate = [
    {
      Text: 'A post with text',
      'Image URL': undefined,
      Tags: undefined,
      'Posting Time': `${format(tomorrow, 'yyyy-MM-dd')} 17:30`,
    },
    {
      Text: 'A post with text and an image',
      'Image URL':
        imageOptions[Math.floor(Math.random() * imageOptions.length)],
      Tags: undefined,
      'Posting Time': undefined,
    },
    {
      Text: 'A post with text and tags - must be existing tags',
      'Image URL': undefined,
      Tags: tags,
      'Posting Time': undefined,
    },
  ]

  if (channelService === 'pinterest') {
    const defaultBoard = existingBoards?.[0]?.name ?? 'Pets'
    return baseTemplate.map((row, index) => ({
      ...row,
      // Image URL is required for Pinterest
      'Image URL':
        imageOptions[Math.floor(Math.random() * imageOptions.length)],
      // Board Name is required for Pinterest
      'Board Name': existingBoards?.[index]
        ? existingBoards[index].name
        : defaultBoard,
      // Optional columns should be present, but empty.
      // leaving a first-row sample for the CSV template for better UX.
      ...(index === 0
        ? {
            Title: 'Beautiful nature waterfall',
            'Alt Text':
              'Waterfall cascading into a turquoise pool surrounded by tropical plants',
            Link: 'https://example.com/nature-waterfalls',
          }
        : {}),
    }))
  }

  return baseTemplate
}
